import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface VoiceSimulationDialogData {
  partitions: { _id: string; name: string; account: string }[];
}

@Component({
  selector: 'app-voice-simulation-dialog',
  templateUrl: './voice-simulation-dialog.component.html',
  styleUrls: ['./voice-simulation-dialog.component.scss'],
})
export class VoiceSimulationDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<VoiceSimulationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VoiceSimulationDialogData,
    private readonly fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      partitionId: [null, Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{8,15}$/)]],
      safeWord: [''],
    });
  }

  onConfirm(): void {
    if (this.form.invalid) return;
    this.dialogRef.close({ status: 'simulate', ...this.form.value });
  }

  onCancel(): void {
    this.dialogRef.close({ status: 'cancel' });
  }
}
